// @ts-nocheck
import { StorefrontAccess } from "@insite/client-framework/Services/SettingsService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getIsSignedIn } from "@store/Framework/Store/Foundation/Context/ContextSelectors";

export const getWebsite = (state: ApplicationState) => {
    return state.context.website;
};

export const getWebsiteName = (state: ApplicationState) => {
    return getWebsite(state).name;
};

export const getDisplayProductPricesPolicy = (state: ApplicationState) => {
    return getSettingsCollection(state).bunzlSettings?.displayProductPricesPolicy;
};

export const getSignInRequiredToAddToCartOrSeePrices = (state: ApplicationState) => {
    const productSettings = getSettingsCollection(state).productSettings;
    return productSettings.storefrontAccess === StorefrontAccess.SignInRequiredToAddToCartOrSeePrices;
};

export const getIsSignedInAndhasToBeSignedIn = (state: ApplicationState) => {
    const isSignedIn = getIsSignedIn(state);
    const signInRequiredToAddToCartOrSeePrices = getSignInRequiredToAddToCartOrSeePrices(state);

    if (signInRequiredToAddToCartOrSeePrices) {
        return isSignedIn;
    }

    return true;
};

export const getCanShowInventory = (state: ApplicationState) => {
    return getSettingsCollection(state).productSettings.showInventoryAvailability;
};
